document.addEventListener('DOMContentLoaded', () => {
	const bar   = document.getElementById('marquee-bar');
	const close = document.getElementById('marquee-close');

	if (!bar || !close) return;

	close.addEventListener('click', () => {
		bar.style.transition = 'opacity 0.3s, max-height 0.4s';
		bar.style.overflow   = 'hidden';
		bar.style.opacity    = '0';
		bar.style.maxHeight  = bar.scrollHeight + 'px';

		requestAnimationFrame(() => {
			bar.style.maxHeight = '0';
			bar.style.padding   = '0';
		});

		bar.addEventListener('transitionend', () => bar.remove(), { once: true });
	});
});
